import React from 'react';
import { Icon } from './Icon.tsx';
import { Typography } from './Typography.tsx';

interface SectionProps {
    title?: string;
    icon?: string;
    children: React.ReactNode;
    className?: string;
    id?: string;
    description?: string;
}

export const Section: React.FC<SectionProps> = ({
    title,
    icon,
    children,
    className = '',
    id,
    description
}) => (
        <section id={id} className={`space-y-4 ${className}`}>
            {(title || icon) ? <header className="mb-4 border-gray-200 border-b pb-3 dark:border-border-dark">
                    <div className="flex items-center gap-2">
                        {icon ? <Icon name={icon} className="text-primary" size="lg" /> : null}
                        {title ? <Typography variant="h2" weight="bold">
                                {title}
                            </Typography> : null}
                    </div>
                    {description ? <Typography variant="body-sm" color="muted" className="mt-1">
                            {description}
                        </Typography> : null}
                </header> : null}
            <div className="section-content">
                {children}
            </div>
        </section>
    );














